import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PlatformAuthSurface } from "@/components/PlatformAuthSurface";
import { useAuth } from "@/lib/auth";
import { ROUTES } from "@/routes";

/**
 * Primary console sign-up entry (Auth v2).
 * Uses private first-party platform auth — not Hosted portal transaction login.
 */
export function SignupPage() {
  const navigate = useNavigate();
  const { user, loading, setSession } = useAuth();

  useEffect(() => {
    if (!loading && user?.status === "active") {
      navigate(ROUTES.projects, { replace: true });
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <main className="auth-page flex min-h-dvh items-center justify-center bg-background px-4">
        <p className="text-sm text-text-muted" role="status">
          Restoring session…
        </p>
      </main>
    );
  }

  if (user?.status === "active") {
    return null;
  }

  return (
    <main className="auth-page flex min-h-dvh items-center justify-center bg-background px-4 py-10">
      <PlatformAuthSurface
        defaultView="sign-up"
        onAuthenticated={(session) => {
          setSession(session);
          navigate(ROUTES.projects, { replace: true });
        }}
      />
    </main>
  );
}
